import './Checkbox.css'

interface Props
{
    title: string
    horizontal?: boolean
    checked: boolean
    onChange: React.ChangeEventHandler<HTMLInputElement> | undefined
}
const Checkbox = (props: Props) =>
{
    return (
        <div className={`d-flex align-items-center checkbox-container ${props.horizontal ? 'flex-row' : 'flex-column'}`}>
            <input type="checkbox" checked={props.checked} onChange={props.onChange} />
            <div>{props.title}</div>
        </div>
    )
}

export default Checkbox